/* Publish by EComposer at 2026-10-26 02:23:19*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-79i2wmkhw9k"]=  window.__ectimmers["ecom-79i2wmkhw9k"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-79i2wmkhw9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79i2wmkhw9k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p1jy0ywnkuk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p1jy0ywnkuk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9dqiwk5y3w4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9dqiwk5y3w4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c2knz88qar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c2knz88qar', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cci2etfbkzt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cci2etfbkzt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e0ikadxu7p9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e0ikadxu7p9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4yisbkwsnq7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4yisbkwsnq7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3h3892303ao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3h3892303ao', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bbj0q96e8yn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bbj0q96e8yn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ysnfh83gozf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ysnfh83gozf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6uu20yiq1hn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6uu20yiq1hn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6zys2m373r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6zys2m373r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bv2tueyws04').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bv2tueyws04', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28sixiodtr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28sixiodtr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-89lilrbslzr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-89lilrbslzr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j77b7in6gt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j77b7in6gt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zdtnmreszp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zdtnmreszp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a362e6933b8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a362e6933b8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zp1abec276').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zp1abec276', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-djlm32b0sd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djlm32b0sd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1z9hlw3qkpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1z9hlw3qkpg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-arzhgfnic4u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-arzhgfnic4u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-etolkunswzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-etolkunswzh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4ly4oxsab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4ly4oxsab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d1ts2mfvop5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d1ts2mfvop5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i69v6cvg43').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i69v6cvg43', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u8mxqkmjo2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u8mxqkmjo2a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kcjscdp9ido').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcjscdp9ido', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-we4siyp30tg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-we4siyp30tg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-drfvlotn6v6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-drfvlotn6v6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t4k3wgmc44').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t4k3wgmc44', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xxf58dh12np').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xxf58dh12np', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34pm21sbeng').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34pm21sbeng', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95vognw3f0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95vognw3f0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qqh8wnhnecc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qqh8wnhnecc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ccnudjcxp4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ccnudjcxp4h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ng9y8t58pn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ng9y8t58pn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7jrj2ozqa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7jrj2ozqa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zuu937snbmr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zuu937snbmr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8mqs4o10612').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8mqs4o10612', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x83npqkdn8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x83npqkdn8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wa9m6eokja9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wa9m6eokja9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ly2sdf68el').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ly2sdf68el', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ffridkkzfd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ffridkkzfd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qxgrng6ypxi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qxgrng6ypxi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-diohy15xjcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-diohy15xjcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2yh0uew1ct7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2yh0uew1ct7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pevs8vntrxq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pevs8vntrxq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-03wmeym1aksl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-03wmeym1aksl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5we0b51r1a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5we0b51r1a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mogcbg3ubeg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mogcbg3ubeg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a264sj202r7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a264sj202r7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nrfba0oqqhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nrfba0oqqhb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3qqrxczbjla').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3qqrxczbjla', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9b4s3br5rpm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9b4s3br5rpm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xaqzggm6bgq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xaqzggm6bgq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ase08e8g5of').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ase08e8g5of', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l2fcthiucb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l2fcthiucb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptzwggxmgx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptzwggxmgx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lfyic19j6le').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lfyic19j6le', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ozkrr7eznu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ozkrr7eznu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zu71s8l0d3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zu71s8l0d3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vg0l74nzcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vg0l74nzcr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bdcln69iyek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bdcln69iyek', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ixromcgt3ho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ixromcgt3ho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ot9cvxcg9v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ot9cvxcg9v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gr3pfpayrdr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gr3pfpayrdr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k730lom942d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k730lom942d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2xp0veqeazq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2xp0veqeazq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vlxmnji2jdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vlxmnji2jdh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jckr2cq700a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jckr2cq700a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m16mc74je2d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m16mc74je2d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z7c6dp8qlu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z7c6dp8qlu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cywjgaou3rm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cywjgaou3rm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-niwdady8seb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-niwdady8seb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-og1pwczxfkn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-og1pwczxfkn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fvb78l3jh1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fvb78l3jh1k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tej13982mqf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tej13982mqf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4hjbvxpxuas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4hjbvxpxuas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xpp7ab0q29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xpp7ab0q29', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7nwjyq2yptg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7nwjyq2yptg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qny59531yr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qny59531yr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sd6ovyds8u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sd6ovyds8u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s4y7k7j5i0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s4y7k7j5i0a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-timy5llk5xk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-timy5llk5xk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ki2fafjt9ue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ki2fafjt9ue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kdgcn3wszda').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kdgcn3wszda', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fkswr36nw2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fkswr36nw2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nuvt714roan').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nuvt714roan', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f5kn4n9vf4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f5kn4n9vf4p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ftp8gbo078w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ftp8gbo078w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vqfmvy7ir1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vqfmvy7ir1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1hd8gegecpk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1hd8gegecpk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bzxo0frdjti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bzxo0frdjti', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9s93x27dlxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9s93x27dlxr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wawjnxthl4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wawjnxthl4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ph36q1j799').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ph36q1j799', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yhhtasmd88c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yhhtasmd88c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jw46i7o64f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jw46i7o64f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-juh0tzmo8v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-juh0tzmo8v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d2dvh273a7v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d2dvh273a7v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vf472qzpqa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vf472qzpqa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d0v1fitmui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d0v1fitmui', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-q1tex81beoe"]=  window.__ectimmers["ecom-q1tex81beoe"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-q1tex81beoe"]["v6saebsq8"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-q1tex81beoe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q1tex81beoe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8w88ugnd21').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8w88ugnd21', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ird6or01iu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ird6or01iu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-om2df2sx5tc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-om2df2sx5tc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a01jpfawmx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a01jpfawmx8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6fp8wltbig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6fp8wltbig', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vl9lexhaxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vl9lexhaxl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fpf8bl0cf1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fpf8bl0cf1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nu6a632agd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nu6a632agd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zg2a5sx88m9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zg2a5sx88m9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-92q5v271tvn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-92q5v271tvn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v8xuf2xx0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v8xuf2xx0a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3p2cf3ta4xc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3p2cf3ta4xc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5hi8wlax7mk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5hi8wlax7mk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8jeo47c4uvl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8jeo47c4uvl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zvhkvivxymo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zvhkvivxymo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-feb5lavw6mc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-feb5lavw6mc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bxi4n1d2f5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bxi4n1d2f5g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-16ii1vrlhpx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-16ii1vrlhpx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-caoxaq7vcjb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-caoxaq7vcjb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yuc98oi6ff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yuc98oi6ff', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4gt3ova1jg7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4gt3ova1jg7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-goqrfpn2f6g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-goqrfpn2f6g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24ii7aiyfek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24ii7aiyfek', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bhwsc66jnb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bhwsc66jnb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qo1tgyio4tb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qo1tgyio4tb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a1humeyvatj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a1humeyvatj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xt6bgzyf6s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xt6bgzyf6s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5t0fba8qke').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5t0fba8qke', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-06g3op7k6j6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-06g3op7k6j6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nbcos2rj28g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nbcos2rj28g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-613tf8k5zzp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-613tf8k5zzp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfo76psiwof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfo76psiwof', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qp44td00rhh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qp44td00rhh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iyrjl5rvwvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iyrjl5rvwvo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oztpbue1j2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oztpbue1j2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-spbgtmg23b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-spbgtmg23b', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-t4wvgs3o5qf"]=  window.__ectimmers["ecom-t4wvgs3o5qf"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-t4wvgs3o5qf"]["vy2of7jf4"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-t4wvgs3o5qf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t4wvgs3o5qf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nwiqqrh8vdm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nwiqqrh8vdm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lqkvre6lhk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lqkvre6lhk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c63z1h14its').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c63z1h14its', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vi9dbw4th5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vi9dbw4th5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tlqnq3b761f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tlqnq3b761f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7jzjb5cwbtq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7jzjb5cwbtq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ys6dx3bgxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ys6dx3bgxl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bugxry9erre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bugxry9erre', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ctrl7uhl5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ctrl7uhl5o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s87eai9vqpp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s87eai9vqpp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j03vm6wbama').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j03vm6wbama', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1nlderyyq8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1nlderyyq8o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-crcoefkusl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-crcoefkusl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hybtnlpfb18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hybtnlpfb18', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ynyn8e8j4w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ynyn8e8j4w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95ek3kdxj9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95ek3kdxj9r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-thiv6xm16ob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-thiv6xm16ob', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2w2fv50ks19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2w2fv50ks19', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4lgeji5arr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4lgeji5arr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j6cdqop3s6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j6cdqop3s6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6okhd7ll0qh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6okhd7ll0qh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5pw43a5wp3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5pw43a5wp3g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}